(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9543],{

/***/ 21177:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-journal",
      function () {
        return __webpack_require__(34899);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qW": function() { return /* reexport */ black_membership; },
  "YZ": function() { return /* reexport */ black_plus_membership; },
  "Xs": function() { return /* reexport */ dynasty_dining_membership; },
  "b0": function() { return /* reexport */ dynasty_membership; },
  "s7": function() { return /* reexport */ gold_membership; },
  "CY": function() { return /* reexport */ partners_footer; },
  "Vo": function() { return /* reexport */ partners_header; },
  "YN": function() { return /* reexport */ travel_journal_hero; }
});

// UNUSED EXPORTS: silverMembershipPNG

;// CONCATENATED MODULE: ./assets/black_membership.png
/* harmony default export */ var black_membership = ({"src":"/_next/static/media/black_membership.89d63625.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAADFBMVEVCQUEZGRgpJyU1NTWqJWHDAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAALEwAACxMBAJqcGAAAACJJREFUeJwlyLcNAAAMwzDJ+f/ntI0gEDUCpWGxdQPqowYNAzgAIjLrfacAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/black_plus_membership.png
/* harmony default export */ var black_plus_membership = ({"src":"/_next/static/media/black_plus_membership.0bde2d9f.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAD1BMVEVEQ0IbGxoXFxcqKSc9PT16xy8BAAAAAnRSTlP+/qap3hAAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAkSURBVHicLYpBCgAwDIOM6f/fPFp2UkSgmgYYLSv0Fybq8q4HBQ4AOvZNNcYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/gold_membership.png
/* harmony default export */ var gold_membership = ({"src":"/_next/static/media/gold_membership.87a9fcf4.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAADFBMVEW4pYO9sZujknStnYCsT/YOAAAAAnRSTlP//r+y71EAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAhSURBVHicY2BgYGJiYmJmYmAAsZgZwQxmmAhYEsxgBjIABMsANYW/9jkAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/silver_membership.png
/* harmony default export */ var silver_membership = ({"src":"/_next/static/media/silver_membership.99059e53.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAElBMVEXu7u7j4+Opqann5+fc3NzMzMwDuZyoAAAAA3RSTlP//v6U1OMbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJElEQVR4nDXIwQ0AMAjEsISD/VdGqOrPMqD2CGCm+pA/aB6iLgVgADdKWKYDAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/dynasty_membership.png
/* harmony default export */ var dynasty_membership = ({"src":"/_next/static/media/dynasty_membership.58020613.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAADFBMVEX8+/vr5dr29fX///+42Y7TAAAAAnRSTlP+/qap3hAAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAiSURBVHicNcnBDQAgDIBACvvvbLTxdwGUQlDLeeAX694VBwZNAEu+pEB8AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/dynasty_dining_membership.png
/* harmony default export */ var dynasty_dining_membership = ({"src":"/_next/static/media/dynasty_dining_membership.d56ef584.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAADFBMVEXt6+n+/v719fP49/c+D7RfAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAALEwAACxMBAJqcGAAAACNJREFUeJwlycEJACAAxLC2t//Oov4CoaYmDzFacwntnvBzBwZRAEV/XscNAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/partners_header.png
/* harmony default export */ var partners_header = ({"src":"/_next/static/media/partners_header.754372d5.png","height":1078,"width":2560,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAALVBMVEWCobl/hHVjcXNybWFjWzVzdHWbs8KMlparxtRqZ1xUTzyNpsBrj7d8hIt5ZEqXgokiAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAI0lEQVR4nGNg4+Bg42ZnZGJgZGdg4GFiYWHgYuVl5mRl5gMABygAjnnBLYwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./assets/partners_footer.png
/* harmony default export */ var partners_footer = ({"src":"/_next/static/media/partners_footer.5891e7bd.png","height":1020,"width":2560,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAJFBMVEWiop+SlJepoZzAwb6NiYd/dnSekY2Hl6eYiH5XXm+sucuJhoTZ61KHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAI0lEQVR4nGPgYGZhZGLiYmRgY2ZgYOVm4GbgZGdnZGVjZgIABX0AbOskcGoAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./assets/travel-journal-hero.webp
/* harmony default export */ var travel_journal_hero = ({"src":"/_next/static/media/travel-journal-hero.851e428d.webp","height":563,"width":1920,"blurDataURL":"data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACwAQCdASoIAAIAAkA4JZwCdAEO/dXAAP6mz7c6epO1LQQoT94gygxSSdbqBoAA","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./assets/index.ts












/***/ }),

/***/ 94082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layouts_GlobalLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./blocks/DialoguePresenter/DialoguePresenter.tsx
var DialoguePresenter = __webpack_require__(38114);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(92557);
// EXTERNAL MODULE: ./customHooks/useLocalised/useLocalised.ts + 2 modules
var useLocalised = __webpack_require__(91933);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
// EXTERNAL MODULE: ./data/translationKeys.ts
var translationKeys = __webpack_require__(698);
// EXTERNAL MODULE: ./components/NavigationItem/NavigationItem.tsx
var NavigationItem = __webpack_require__(10493);
// EXTERNAL MODULE: ./components/icons/LittleEmperorsIcon.tsx
var LittleEmperorsIcon = __webpack_require__(21965);
// EXTERNAL MODULE: ./customHooks/useDialogue/useDialogue.ts
var useDialogue = __webpack_require__(82113);
// EXTERNAL MODULE: ./components/icons/BurgerMenuIcon.tsx
var BurgerMenuIcon = __webpack_require__(61063);
// EXTERNAL MODULE: ./components/icons/LittleEmperorsTextIcon.tsx
var LittleEmperorsTextIcon = __webpack_require__(15096);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
;// CONCATENATED MODULE: ./components/icons/BurgerMenuCloseIcon.tsx

var BurgerMenuCloseIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#A)",
                "fill-rule": "evenodd",
                fill: "#fff",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.497 3.493a.5.5 0 0 1 .707 0l16.305 16.305a.5.5 0 0 1-.707.707L3.497 4.2a.5.5 0 0 1 0-.707z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.502 3.491a.5.5 0 0 1 0 .707L4.198 20.503a.5.5 0 1 1-.707-.707L19.795 3.491a.5.5 0 0 1 .707 0z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "A",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icons_BurgerMenuCloseIcon = (BurgerMenuCloseIcon);

;// CONCATENATED MODULE: ./blocks/Header/Header.tsx














var Header = function() {
    var join_us_text = (0,useLocalised/* default */.Z)(translationKeys.join_us);
    var sign_in_text = (0,useLocalised/* default */.Z)(translationKeys.sign_in);
    var ref = (0,react.useContext)(useDialogue/* DialogueContext */.$), openDialogue = ref.openDialogue, closeDialogue = ref.closeDialogue, dialogueState = ref.dialogueState;
    var isMobileMenuOpen = dialogueState.presentedDialogueType === constants/* MOBILE_MENU_DIALOGUE */.uN;
    var handleClickOnSignIn = (0,react.useCallback)(function() {
        openDialogue(constants/* SIGN_IN_DIALOG */.jt);
    }, [
        openDialogue
    ]);
    var handleClickOnJoinUs = (0,react.useCallback)(function() {
        openDialogue(constants/* JOIN_US_DIALOG_STEP_1 */.le);
    }, [
        openDialogue
    ]);
    var handleBurgerMenuClick = (0,react.useCallback)(function() {
        openDialogue(constants/* MOBILE_MENU_DIALOGUE */.uN);
    }, [
        openDialogue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "header-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "header-component__container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Hotels",
                            path: constants/* navigationPaths.OUR_HOTELS */.aY.OUR_HOTELS,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Membership",
                            path: constants/* navigationPaths.MEMBERSHIP */.aY.MEMBERSHIP,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Gift cards",
                            path: constants/* navigationPaths.E_GIFT_CARD */.aY.E_GIFT_CARD,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Discover MyLER",
                            path: constants/* navigationPaths.DISCOVER_MYLER */.aY.DISCOVER_MYLER,
                            className: "header-navigation-item"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "burger-icon",
                    children: [
                        !isMobileMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: handleBurgerMenuClick,
                            title: "mobile-menu",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerMenuIcon/* default */.Z, {})
                        }),
                        isMobileMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: closeDialogue,
                            title: "mobile-menu",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_BurgerMenuCloseIcon, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: constants/* navigationPaths.HOMEPAGE */.aY.HOMEPAGE,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "area-label": "homepage",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LittleEmperorsIcon/* default */.Z, {
                                    color: constants/* colorConstants.brandColor */.Q_.brandColor
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: constants/* navigationPaths.HOMEPAGE */.aY.HOMEPAGE,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "area-label": "homepage",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LittleEmperorsTextIcon/* default */.Z, {
                                    color: constants/* colorConstants.brandColor */.Q_.brandColor
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-rigth",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            title: join_us_text,
                            onClick: handleClickOnJoinUs,
                            buttonType: Button/* LINK_BUTTON_TYPE */.II,
                            className: "header-join_us_text_button"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            title: sign_in_text,
                            onClick: handleClickOnSignIn,
                            buttonType: Button/* LINK_BUTTON_TYPE */.II,
                            className: "header-navigation-item"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Header_Header = (Header);

// EXTERNAL MODULE: ./blocks/Footer/Footer.tsx + 2 modules
var Footer = __webpack_require__(93335);
;// CONCATENATED MODULE: ./utils/header.ts
function formatCanonicalUrl(url) {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
        return url;
    }
    return url.replace(/^https?:\/\/(www\.)?/, "https://");
}
// gets first sentence or two from some copy
function getDescriptionFromContent(text) {
    if (!text) {
        return "";
    }
    var sentences = text.match(/[^.!?]+[.!?](?=\s+|$)/g);
    if (!sentences) {
        return text;
    }
    // help avoid splitting on common abbreviations  
    var abbreviations = /\b(?:[A-Z]\.|(?:[A-Z]\w{0,2}\.){2,}|e\.g\.|i\.e\.)/i;
    var combinedText = sentences[0].trim();
    // sensible minimum length for description
    if (combinedText.length > 90) {
        return combinedText;
    }
    for(var i = 1; i < sentences.length; i++){
        if (abbreviations.test(sentences[i])) {
            combinedText += " " + sentences[i].trim();
            continue;
        }
        combinedText += " " + sentences[i].trim();
        if (combinedText.length > 90) {
            return combinedText;
        }
    }
    return text;
}

;// CONCATENATED MODULE: ./blocks/Layouts/GlobalLayout.tsx



//Components



var GlobalLayout = function(param) {
    var children = param.children, memberships = param.memberships, currencies = param.currencies, countryCodes = param.countryCodes, metaData = param.metaData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "MyLE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: metaData.url
                    }),
                    metaData.type && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: metaData.type
                    }),
                    metaData.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: metaData.image
                    }),
                    metaData.author && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: metaData.author
                    }),
                    metaData.publishedTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:published_time",
                        content: metaData.publishedTime
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: formatCanonicalUrl(metaData.url)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "main-content-container",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialoguePresenter/* default */.Z, {
                memberships: memberships,
                currencies: currencies,
                countryCodes: countryCodes
            })
        ]
    });
};
/* harmony default export */ var Layouts_GlobalLayout = (GlobalLayout);


/***/ }),

/***/ 21569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ article_grid_ArticleGrid; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/Articles.module.scss
var Articles_module = __webpack_require__(18427);
var Articles_module_default = /*#__PURE__*/__webpack_require__.n(Articles_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/articles-card/full-background-img-article-card/FullBackgroundImgArticleCard.module.scss
var FullBackgroundImgArticleCard_module = __webpack_require__(96486);
var FullBackgroundImgArticleCard_module_default = /*#__PURE__*/__webpack_require__.n(FullBackgroundImgArticleCard_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/container/index.ts
var container = __webpack_require__(49985);
// EXTERNAL MODULE: ./components/text/index.ts
var components_text = __webpack_require__(22538);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/articles-card/full-background-img-article-card/FullBackgroundImgArticleCard.tsx






var FullBackgroundImgArticleCard = function(param) {
    var article = param.article;
    var title = article.title, header_image = article.header_image, introduction = article.introduction, categories = article.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        className: (FullBackgroundImgArticleCard_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
            className: (FullBackgroundImgArticleCard_module_default()).imageContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (FullBackgroundImgArticleCard_module_default()).cardHeader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (FullBackgroundImgArticleCard_module_default()).categories,
                            children: categories === null || categories === void 0 ? void 0 : categories.map(function(category, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                    color: "white",
                                    weight: "demiBold",
                                    children: category.name
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                            as: "h4",
                            color: "white",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (FullBackgroundImgArticleCard_module_default()).introduction,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                color: "white",
                                fontSize: 18,
                                children: introduction
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: header_image,
                    layout: "fill",
                    objectPosition: "center",
                    objectFit: "cover",
                    alt: title,
                    sizes: "200vw"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                    className: (FullBackgroundImgArticleCard_module_default()).bottomGradient
                })
            ]
        })
    });
};
/* harmony default export */ var full_background_img_article_card_FullBackgroundImgArticleCard = (FullBackgroundImgArticleCard);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/articles-card/full-background-img-article-card/index.ts


// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/articles-card/article-card/ArticleCard.module.scss
var ArticleCard_module = __webpack_require__(16017);
var ArticleCard_module_default = /*#__PURE__*/__webpack_require__.n(ArticleCard_module);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/articles-card/article-card/ArticleCard.tsx






var ArticleCard = function(param) {
    var article = param.article;
    var title = article.title, introduction = article.introduction, header_image = article.header_image, categories = article.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        className: (ArticleCard_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                className: (ArticleCard_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    priority: true,
                    src: header_image,
                    layout: "fill",
                    objectPosition: "center",
                    objectFit: "cover",
                    alt: title,
                    sizes: "(max-width: 768px) 100vw, (max-width: 1024px) 100vw, 640px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ArticleCard_module_default()).cardHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ArticleCard_module_default()).categories,
                        children: categories === null || categories === void 0 ? void 0 : categories.map(function(category, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                color: "gold-dark",
                                weight: "demiBold",
                                children: category.name
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                        as: "h4",
                        color: "grey-dark",
                        weight: "medium",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ArticleCard_module_default()).introduction,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                            color: "grey-dark",
                            fontSize: 18,
                            children: introduction
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var article_card_ArticleCard = (ArticleCard);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/articles-card/article-card/index.ts


// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/article-link/index.ts + 1 modules
var article_link = __webpack_require__(3621);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/article-grid/ArticleGrid.tsx






var ArticleGrid = function(param) {
    var articles = param.articles, _showWide = param.showWide, showWide = _showWide === void 0 ? true : _showWide;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        as: "section",
        className: "".concat((Articles_module_default()).articlesGrid, " ").concat(showWide ? (Articles_module_default()).showWide : ""),
        children: articles.map(function(article, index) {
            if (!article) return null;
            var CardComponent = showWide && [
                0,
                5
            ].includes(index) ? full_background_img_article_card_FullBackgroundImgArticleCard : article_card_ArticleCard;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_link/* default */.Z, {
                article: article,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardComponent, {
                    article: article
                })
            }, article.id);
        })
    });
};
/* harmony default export */ var article_grid_ArticleGrid = (ArticleGrid);


/***/ }),

/***/ 3621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ article_link_ArticleLink; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/article-link/ArticleLink.tsx


var ArticleLink = function(param) {
    var article = param.article, children = param.children;
    var encodedSlug = encodeURIComponent(article.slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/travel-journal/".concat(encodedSlug),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: children
            })
        })
    }, article.id);
};
/* harmony default export */ var article_link_ArticleLink = (ArticleLink);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/article-link/index.ts



/***/ }),

/***/ 19096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var CategoryLink = function(param) {
    var category = param.category, children = param.children;
    var encodedSlug = encodeURIComponent(category.slug);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/travel-journal/".concat(encodedSlug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: children
        })
    }, category.id);
};
/* harmony default export */ __webpack_exports__["Z"] = (CategoryLink);


/***/ }),

/***/ 26850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _CategoryLink__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _CategoryLink__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19096);



/***/ }),

/***/ 41107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HB": function() { return /* binding */ FILLED_BUTTON_TYPE_DARK; },
/* harmony export */   "II": function() { return /* binding */ LINK_BUTTON_TYPE; },
/* harmony export */   "ME": function() { return /* binding */ FILLED_BUTTON_TYPE; },
/* harmony export */   "Wr": function() { return /* binding */ OUTLINED_BUTTON_TYPE_DARK; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_Spinner_Spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95475);



var LINK_BUTTON_TYPE = "LINK_BUTTON_TYPE";
var FILLED_BUTTON_TYPE = "FILLED_BUTTON_TYPE";
var FILLED_BUTTON_TYPE_DARK = "FILLED_BUTTON_TYPE_DARK";
var OUTLINED_BUTTON_TYPE_DARK = "OUTLINED_BUTTON_TYPE_DARK";
var Button = function(param) {
    var title = param.title, onClick = param.onClick, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? FILLED_BUTTON_TYPE : _buttonType, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, className = param.className, htmlAttributes = param.htmlAttributes;
    var handleOnClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (isLoading) {
            return;
        }
        onClick();
    }, [
        isLoading,
        onClick
    ]);
    var getClass = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var classNameArray = [];
        var inititalClassName = "button-body-filled";
        switch(buttonType){
            case LINK_BUTTON_TYPE:
                inititalClassName = "button-body-link";
                break;
            case FILLED_BUTTON_TYPE_DARK:
                inititalClassName = "button-body-filled-dark";
                break;
            case OUTLINED_BUTTON_TYPE_DARK:
                inititalClassName = "button-body-outlined-dark";
            default:
                break;
        }
        classNameArray.push(inititalClassName);
        if (className) {
            classNameArray.push(className);
        }
        return classNameArray.join(" ");
    }, [
        buttonType,
        className
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        type: htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.type,
        onClick: handleOnClick,
        className: getClass(),
        "area-label": title,
        style: htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.style,
        disabled: (htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.disabled) || false,
        children: [
            !isLoading && title,
            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Spinner_Spinner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Button);


/***/ }),

/***/ 2466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ BaseText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13394);
/* harmony import */ var components_shared_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63057);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4093);
/* harmony import */ var _BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5__);








var BaseText = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "p" : _as, children = _param.children, _color = _param.color, color = _color === void 0 ? "black" : _color, weight = _param.weight, fontStyle = _param.fontStyle, letterSpacing = _param.letterSpacing, fontSize = _param.fontSize, align = _param.align, style = _param.style, isLink = _param.isLink, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "as",
        "children",
        "color",
        "weight",
        "fontStyle",
        "letterSpacing",
        "fontSize",
        "align",
        "style",
        "isLink",
        "className"
    ]);
    var colorStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getColorFromString */ .T)(color);
    var fontWeightStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getFontWeightFromString */ .J)(weight);
    var marginStyle = (0,components_shared_utils__WEBPACK_IMPORTED_MODULE_2__/* .getMarginFromProps */ .X)(rest);
    var joinedClassName = classnames__WEBPACK_IMPORTED_MODULE_3___default()((_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default().baseText), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link), isLink), className);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: joinedClassName,
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            fontWeight: fontWeightStyle,
            fontStyle: fontStyle,
            color: colorStyle,
            textAlign: align,
            letterSpacing: letterSpacing,
            fontSize: fontSize
        }, marginStyle, style)
    }, rest), children);
};


/***/ }),

/***/ 7117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);




var Body = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Body);


/***/ }),

/***/ 36443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);
/* harmony import */ var _Heading_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85392);
/* harmony import */ var _Heading_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Heading_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var Heading = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "h1" : _as, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "as"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        as: as,
        className: (_Heading_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[as]
    }, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 82096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Small_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26926);
/* harmony import */ var _Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Small_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var Small = function(_param) {
    var _xs = _param.xs, xs = _xs === void 0 ? false : _xs, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "xs"
    ]);
    var joinedClassNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default().small), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default().xs), xs));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        as: "small",
        className: joinedClassNames
    }, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (Small);


/***/ }),

/***/ 22538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X6": function() { return /* reexport safe */ _Heading__WEBPACK_IMPORTED_MODULE_2__.Z; },
/* harmony export */   "uT": function() { return /* reexport safe */ _Body__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   "x4": function() { return /* reexport safe */ _Small__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var _Body__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7117);
/* harmony import */ var _Small__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82096);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36443);





/***/ }),

/***/ 13394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ getColorFromString; },
  "J": function() { return /* binding */ getFontWeightFromString; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./components/shared/constants.ts
var constants = __webpack_require__(55774);
;// CONCATENATED MODULE: ./components/text/constants.ts
var weights = {
    regular: 400,
    medium: 500,
    demiBold: 600
};

;// CONCATENATED MODULE: ./components/text/utils.ts



var getColorFromString = function(colorString) {
    var ref = (0,_sliced_to_array/* default */.Z)(colorString.split("-"), 2), colorName = ref[0], shade = ref[1];
    var color = shade ? constants/* colors */.O[colorName][shade] : constants/* colors */.O[colorString];
    return color ? color : constants/* colors.black */.O.black;
};
var getFontWeightFromString = function(weightString) {
    if (!weightString) {
        return null;
    }
    var weight = weights[weightString];
    return weight ? weight : weights.regular;
};


/***/ }),

/***/ 34899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ travel_journal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./blocks/Layouts/GlobalLayout.tsx + 3 modules
var GlobalLayout = __webpack_require__(94082);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/hero-section/HeroSection.module.scss
var HeroSection_module = __webpack_require__(98537);
var HeroSection_module_default = /*#__PURE__*/__webpack_require__.n(HeroSection_module);
// EXTERNAL MODULE: ./components/container/index.ts
var container = __webpack_require__(49985);
// EXTERNAL MODULE: ./assets/index.ts + 9 modules
var assets = __webpack_require__(69161);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/category-link/CategoryLink.tsx
var CategoryLink = __webpack_require__(19096);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/hero-section/HeroSection.tsx






var HeroSection = function(param) {
    var categories = param.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        as: "header",
        className: (HeroSection_module_default()).heroSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (HeroSection_module_default()).title,
                children: "Travel Journal"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: assets/* travelJournalHeroWEBP */.YN,
                objectPosition: "center",
                objectFit: "cover",
                alt: "Travel Journal",
                layout: "fill",
                sizes: "200vw"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: (HeroSection_module_default()).categories,
                children: categories.map(function(category) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryLink/* default */.Z, {
                        category: category,
                        children: category.name
                    }, category.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                className: (HeroSection_module_default()).bottomGradient
            })
        ]
    });
};
/* harmony default export */ var hero_section_HeroSection = (HeroSection);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/hero-section/index.ts


// EXTERNAL MODULE: ./components/text/index.ts
var components_text = __webpack_require__(22538);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/introduction/Introduction.module.scss
var Introduction_module = __webpack_require__(33704);
var Introduction_module_default = /*#__PURE__*/__webpack_require__.n(Introduction_module);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/introduction/Introduction.tsx




var Introduction = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        as: "section",
        className: (Introduction_module_default()).introduction,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
            as: "h2",
            fontSize: 18,
            color: "grey-dark",
            weight: "medium",
            children: "Destination guides, hotel reviews, insider tips and travel blogs through a luxury lens."
        })
    });
};
/* harmony default export */ var introduction_Introduction = (Introduction);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/introduction/index.ts


// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/article-grid/ArticleGrid.tsx + 4 modules
var ArticleGrid = __webpack_require__(21569);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/categories-grid/CategoriesGrid.module.scss
var CategoriesGrid_module = __webpack_require__(73574);
var CategoriesGrid_module_default = /*#__PURE__*/__webpack_require__.n(CategoriesGrid_module);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/category-link/index.ts
var category_link = __webpack_require__(26850);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/categories-grid/CategoriesGrid.tsx





var CategoriesGrid = function(param) {
    var categories = param.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        as: "nav",
        className: (CategoriesGrid_module_default()).container,
        children: categories.map(function(category) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CategoriesGrid_module_default()).item,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(category_link/* default */.Z, {
                    category: category,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: category.image,
                            objectPosition: "center",
                            objectFit: "cover",
                            alt: category.name,
                            layout: "fill",
                            sizes: "(max-width: 768px) 100vw, (max-width: 1024px) 640px, 828px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CategoriesGrid_module_default()).itemLabel,
                            children: category.name
                        })
                    ]
                })
            }, category.id);
        })
    });
};
/* harmony default export */ var categories_grid_CategoriesGrid = (CategoriesGrid);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/categories-grid/index.ts


;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/Articles.tsx





var Articles = function(param) {
    var articles = param.articles, categories = param.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_section_HeroSection, {
                categories: categories
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(introduction_Introduction, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleGrid/* default */.Z, {
                articles: articles.slice(0, 6)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleGrid/* default */.Z, {
                articles: articles.slice(6, 12)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(categories_grid_CategoriesGrid, {
                categories: categories
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleGrid/* default */.Z, {
                articles: articles.slice(12, 18)
            })
        ]
    });
};
/* harmony default export */ var home_Articles = (Articles);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/index.ts


;// CONCATENATED MODULE: ./pages/travel-journal/index.tsx





var TravelJournalHome = function(param) {
    var globalLayoutProps = param.globalLayoutProps, articles = param.articles, categories = param.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalLayoutProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(home_Articles, {
            articles: articles,
            categories: categories
        })
    }));
};
var __N_SSG = true;
/* harmony default export */ var travel_journal = (TravelJournalHome);


/***/ }),

/***/ 18427:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articlesGrid":"Articles_articlesGrid__0kbS2","showWide":"Articles_showWide__ja9v3"};

/***/ }),

/***/ 16017:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleCard_container__wb7vV","imageContainer":"ArticleCard_imageContainer__HTlUa","cardHeader":"ArticleCard_cardHeader__Bgt6y","categories":"ArticleCard_categories__K0RzG"};

/***/ }),

/***/ 96486:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FullBackgroundImgArticleCard_container__mlaUR","imageContainer":"FullBackgroundImgArticleCard_imageContainer__JJueg","bottomGradient":"FullBackgroundImgArticleCard_bottomGradient__Vz2d4","cardHeader":"FullBackgroundImgArticleCard_cardHeader__MUgEW","categories":"FullBackgroundImgArticleCard_categories___xMEK","content":"FullBackgroundImgArticleCard_content__TfdJE","introduction":"FullBackgroundImgArticleCard_introduction__AGT3I"};

/***/ }),

/***/ 73574:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoriesGrid_container__awiiH","item":"CategoriesGrid_item__vsloc","itemLabel":"CategoriesGrid_itemLabel__WyM2j"};

/***/ }),

/***/ 98537:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroSection":"HeroSection_heroSection__yuBFJ","title":"HeroSection_title__wjL5O","categories":"HeroSection_categories__QDUyp","active":"HeroSection_active__q_iOm","bottomGradient":"HeroSection_bottomGradient__h70qh"};

/***/ }),

/***/ 33704:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"introduction":"Introduction_introduction__dkVWK"};

/***/ }),

/***/ 4093:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseText":"BaseText_baseText__UdRof","link":"BaseText_link__iIUwY"};

/***/ }),

/***/ 85392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h1":"Heading_h1__JrX4F","h2":"Heading_h2__meWYJ","h3":"Heading_h3__7RMCn","h4":"Heading_h4__IrnJ5","h5":"Heading_h5__pT9p1"};

/***/ }),

/***/ 26926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"small":"Small_small__B42wk","xs":"Small_xs__SqaGj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [48,5675,210,9774,2888,179], function() { return __webpack_exec__(21177); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);